import {TheViewColorizeSchema} from "./types-analytics";
import type {TheViewColorizeType} from "./types-analytics";
import type {GData, Group, SData} from "./components/Colorizer/types";

export const convertTheViewColorizeToTelematicsData = (colorize: TheViewColorizeType, unit: string): SData | GData => {
    try {
        if (colorize?.crit === undefined) {
            colorize.crit = {
                p: false,
                r: '',
                f: '',
            }
        }
        // if (colorize?.related_options === undefined) {
        //     colorize.related_options = {
        //         date_first: null,
        //         date_second: null,
        //         compare_dates: false,
        //     }
        // }
        TheViewColorizeSchema.parse(colorize);
    } catch (e) {
        console.error(e);
        return null;
    }

    if (colorize?.criteria_type === "dictionary") {
        return convertTheViewColorizeToGData(colorize);
    } else {
        return convertTheViewColorizeToSData(colorize, unit);
    }
}

export const convertTheViewColorizeToSData = (colorize: TheViewColorizeType, unit: string): SData => {
    const {v, crit, c, filter,
        v_min, v_max, f } = colorize;
    let blocks: SData['blocks'] = [];

    // Add blocks
    blocks = v.map((value, index) => {
        return {
            id: index,
            max: parseFloat(value as string) || v_max,
            color: '#' + c[index],
            left_px: null,
            left_input_px: null,
            width_px: null,
            infinity_type: "" as "",
            rounded: null,
        }
    })

    // Add last block if not exists
    if (blocks.length>0 && blocks[blocks.length-1].max !== v_max && blocks.length<c.length) {
        blocks.push({
            id: blocks.length,
            max: v_max,
            color: '#' + c[c.length-1],
            left_px: null,
            left_input_px: null,
            width_px: null,
            infinity_type: "" as "",
            rounded: null,
        })
    }

    return {
        blocks: blocks,
        use_filter: (filter !== 0 && filter !== false),
        visible_min: v_min,
        visible_max: v_max,
        slider_width_px: 600,
        slider_height_px: 15,
        selected_option: crit?.f ?? f,
        block_min: null,
        reversed_color_scale: false,
        unit: unit,
        allow_outside_extremum_values: false,
        integers_only: false,
        allow_min_max_symbols: false,
        make_smooth_numbers: false,
        related_options: {
            date_first: (crit?.p === false ? null : crit.p),
            date_second: (crit?.pref && crit.pref || null),
            compare_dates: (crit?.pref && true || false),
            related_collection: (crit?.r ?? null),
        },
    }
}

export const convertTheViewColorizeToGData = (colorize: TheViewColorizeType): GData => {
    try {
        TheViewColorizeSchema.parse(colorize);
    } catch (e) {
        alert(e.message);
        throw new Error(e.message);
    }
    const {v, crit, c, filter, criteria_type, allDictElements, defaultObjectColor, names, s} = colorize;
    return {
        groups: buildGroupsFromDictionary(v, c, names),
        without_filter_ids: [],
        with_filter_ids: [],
        selected_option: crit?.f ?? '',
    }
}

export const buildGroupsFromDictionary = (v: string[] | number[], c: string[], names: string[]): GData['groups'] => {
    let groups: Group[] = [];
    names.forEach( (name, index) => {
        if (groups.map(g => g.name).includes(name)) {
            groups[groups.map(g => g.name).indexOf(name)].element_ids.push(v[index]);
        } else {
            groups.push({
                id: groups.length,
                name: name,
                color: '#' + c[index],
                is_removable: true,
                is_name_auto_created: false,
                element_ids: [v[index]],
            })
        }
    });
    return groups;
}

// RANGE
// const TheViewColorize = {
//     "v": [
//         "13028",
//         "26055",
//         "39083",
//         "52110",
//         "NaN"
//     ],
//     "crit": {
//         "f": "c_dist_hiper",
//         "p": false
//     },
//     "c": [
//         "5CFF67",
//         "DEFF5C",
//         "FFB85C",
//         "FF875C",
//         "FF5C72"
//     ],
//     "filter": false,
//     "v_min": 0,
//     "v_max": 65138,
//     "qc": 5,
//     "f": "c_dist_hiper",
//     "f_out": "c_dist_hiper",
//     "s": true
// }


// DICTIONARY
// {
//   "v": [
//     "3",
//     "51",
//     "59",
//     "37",
//     "56"
//   ],
//   "crit": {
//     "f": "c_network",
//     "p": false
//   },
//   "c": [
//     "a50026",
//     "a50026",
//     "a50026",
//     "d73027",
//     "d73027"
//   ],
//   "filter": 0,
//   "criteria_type": "dictionary",
//   "allDictElements": 72,
//   "defaultObjectColor": "CCCCCC",
//   "names": [
//     "Grupa 1",
//     "Grupa 1",
//     "Grupa 1",
//     "Grupa 2",
//     "Grupa 2"
//   ],
//   "s": true
// }
